module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Green Closed.a09c91fc.png";